



















































































import { addSelectItem, createSelectItemList } from '@/api/admin'
import { defineComponent, ref } from '@vue/composition-api'
import { SelectItem as SelectItemType } from '@/api/types-app'
import SelectItem from './SelectItem.vue'

export default defineComponent({
  name: 'SelectItemsList',
  components: {
    SelectItem
  },
  setup() {
    const selectItemListName = ref(null)
    const editMode = ref(false)
    const selectItemModal = ref(false)
    const selectItemListModal = ref(false)
    const newSelectItemListName = ref(null)
    const currentSelectItem = ref<SelectItemType | null>(null)

    const closeModal = () => {
      selectItemListModal.value = false
      editMode.value = false
      currentSelectItem.value = null
    }

    const editItem = (selectItem: SelectItemType) => {
      editMode.value = true
      selectItemModal.value = true
      currentSelectItem.value = selectItem
    }

    const newItem = () => {
      selectItemModal.value = true
      currentSelectItem.value = {
        selectItemGroup: selectItemListName.value.selectItemListName,
        key: '',
        captureValue: '',
        pdrValue: '',
        sortOrder: 1
      }
    }

    const newSelectItemList = async() => {
      selectItemListModal.value = true
      const data = {
        selectItemListName: newSelectItemListName.value,
        key: (newSelectItemListName.value as string).substring(0, 1).toLowerCase() + (newSelectItemListName.value as string).substring(1)
      }
      const request = await createSelectItemList(data)
      // eslint-disable-next-line no-self-assign
      if (request) window.location.href = window.location.href
    }

    return {
      editMode,
      selectItemListName,
      selectItemModal,
      selectItemListModal,
      currentSelectItem,
      closeModal,
      newItem,
      editItem,
      newSelectItemList,
      newSelectItemListName
    }
  },
  watch: {
    selectItemListName(val) {
      this.selectItemListNameObject = val
      console.log(val)
    }
  }
})
